import { Controller } from "@hotwired/stimulus"

// Shows another booking on this calendar for the time typed in the form.
export default class extends Controller {
  static targets = ["date", "time", "duration", "list"]
  static values = { url: String }

  connect() {
    this.refresh()
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  schedule() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.refresh(), 200)
  }

  async refresh() {
    if (!this.hasListTarget || !this.urlValue) return
    const params = new URLSearchParams({
      on_date: this.hasDateTarget ? this.dateTarget.value : "",
      start_time: this.hasTimeTarget ? this.timeTarget.value : "",
      duration_minutes: this.hasDurationTarget ? this.durationTarget.value : ""
    })
    const joiner = this.urlValue.includes("?") ? "&" : "?"
    try {
      const response = await fetch(`${this.urlValue}${joiner}${params}`, {
        headers: { Accept: "application/json" },
        credentials: "same-origin"
      })
      if (!response.ok) {
        this.render([])
        return
      }
      const body = await response.json()
      this.render(Array.isArray(body.conflicts) ? body.conflicts : [])
    } catch (_error) {
      this.render([])
    }
  }

  render(conflicts) {
    this.listTarget.replaceChildren()
    if (conflicts.length === 0) {
      this.listTarget.hidden = true
      return
    }
    conflicts.forEach((line) => {
      const row = document.createElement("span")
      row.className = "schedule-conflict__item"
      row.textContent = String(line)
      this.listTarget.append(row)
    })
    this.listTarget.hidden = false
  }
}
